/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Zotero_Reading_Group_MetaInputs */

const en_why_listening_zotero_reading_group_meta = /** @type {(inputs: Why_Listening_Zotero_Reading_Group_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading group`)
};

const es_why_listening_zotero_reading_group_meta = /** @type {(inputs: Why_Listening_Zotero_Reading_Group_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de lectura`)
};

/**
* | output |
* | --- |
* | "Reading group" |
*
* @param {Why_Listening_Zotero_Reading_Group_MetaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_zotero_reading_group_meta = /** @type {((inputs?: Why_Listening_Zotero_Reading_Group_MetaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Zotero_Reading_Group_MetaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_zotero_reading_group_meta(inputs)
	return en_why_listening_zotero_reading_group_meta(inputs)
});